/**
 * The free in-person mock test event.
 *
 * One place to change the date, because it is now referenced from both the
 * promo page and the landing-page section. Two copies of a date is how a site
 * ends up advertising an event that already happened.
 */

/** Dhaka is UTC+6; the offset is explicit so "days left" means the same thing
 *  wherever the reader is. */
export const EVENT_DATE_ISO = "2026-09-09T00:00:00+06:00"
export const EVENT_DATE_LABEL = "9th September, 2026"

/** Fallback only. The live values come from the admin-set slot via
 *  `useFreeMockSlot`; these stand in until that resolves, and if it fails. */
export const EVENT_LOCATION_LABEL = "In person, Dhaka"

/** Seats per sitting. A hard capacity, not a marketing number — the room only
 *  holds this many, so the page states it in one place rather than three. */
export const EVENT_SEAT_CAP = 10

export const EVENT_POSTER = "/assets/in-house-mock.jpeg"
export const EVENT_POSTER_SIZE = { width: 1254, height: 1254 }

export const EVENT_HREF = "/in-house-mock-test"

/** Real, already-published channels — see src/app/contact/page.tsx. */
export const EVENT_WHATSAPP =
    "https://api.whatsapp.com/send/?phone=8801766966772&text&type=phone_number&app_absent=0"
export const EVENT_FACEBOOK = "https://www.facebook.com/dsatschool"
export const EVENT_DISCORD = "https://discord.gg/66j2f4wnA4"

export function eventHasPassed(now: number = Date.now()): boolean {
    return now > new Date(EVENT_DATE_ISO).getTime()
}

/** Whole days remaining, floored, never negative. */
export function daysUntilEvent(now: number = Date.now()): number {
    const ms = new Date(EVENT_DATE_ISO).getTime() - now
    return Math.max(0, Math.floor(ms / 86_400_000))
}
